// extracted by mini-css-extract-plugin
export var details = "_dy-0";
export var inspectorPopover = "_dy-1";